var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQualityAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.7143H4.06706C4.10952 20.7143 4.14734 20.6875 4.16141 20.6474L6.5204 13.9285C6.55233 13.8376 6.68176 13.84 6.71028 13.932L10.6374 26.6086C10.6684 26.7086 10.8127 26.6998 10.8313 26.5968L14.6119 5.62258C14.6321 5.51047 14.7941 5.51396 14.8094 5.62684L16.8503 20.6278C16.857 20.6773 16.8994 20.7143 16.9494 20.7143H19",
    stroke: "#FF5151",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0003,
    cy: 21,
    r: 5.83333,
    stroke: "#FF5151",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6386 18.0542H24.3698V18.3254L24.4136 22.0004H25.5948L25.6386 18.3254V18.0542ZM24.9998 22.6129C24.5973 22.6129 24.3086 22.9279 24.3086 23.2867C24.3086 23.6629 24.5973 23.9517 24.9998 23.9517C25.4023 23.9517 25.6911 23.6629 25.6911 23.2867C25.6911 22.9279 25.4023 22.6129 24.9998 22.6129Z",
    fill: "#FF5151"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityAlert);
export default __webpack_public_path__ + "static/media/qualityAlert.79259433270bbf90254187d914f14c26.svg";
export { ForwardRef as ReactComponent };